import { useState } from 'react'
import { Pencil } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { usePermission } from '@/features/auth/store'
import { CustomerEditForm } from './CustomerEditForm'
import type { Customer } from '../types'

export function CustomerEditButton({ customer }: { customer: Customer }) {
  const canEdit = usePermission('partners.customer.edit')
  const [open, setOpen] = useState(false)
  if (!canEdit) return null

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="outline" size="sm" className="gap-2">
          <Pencil className="size-4" />
          Edytuj
        </Button>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Edytuj klienta</SheetTitle>
          <SheetDescription>Aktualizacja danych podstawowych i przypisań.</SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-6">
          <CustomerEditForm
            customer={customer}
            onSuccess={() => setOpen(false)}
            onCancel={() => setOpen(false)}
          />
        </div>
      </SheetContent>
    </Sheet>
  )
}
